var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { outOfSyncErrorMessage, syncStorageKey } from 'constants/autosave';
import { useFlagEnabled } from 'flagging/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { useAxios } from 'shared/hooks';
import { queryCache } from '../../../../reactQuery';
import { useNoteSetupContext } from 'shared/features/note-setup';
/**
 * One stop shop for putting or posting a note, and updating
 * the local note* cache with the response.
 */
export var useSaveNote = function (_a) {
    var onSuccess = _a.onSuccess, onError = _a.onError, onSettled = _a.onSettled;
    var queryClient = useQueryClient();
    var axios = useAxios();
    var autosaveEnabled = useFlagEnabled('ENABLE_AUTOSAVE');
    var noteSetupState = useNoteSetupContext();
    return useMutation(function (values) {
        var _a, _b;
        // only need to check existing note case, if this is a new note then it will error on 1 note per appointment validation
        if (values.id && autosaveEnabled) {
            var localStorageUpdatedAt = window.localStorage.getItem(syncStorageKey((_a = values.id) !== null && _a !== void 0 ? _a : ''));
            var sessionStorageUpdatedAt = window.sessionStorage.getItem(syncStorageKey((_b = values.id) !== null && _b !== void 0 ? _b : ''));
            if (localStorageUpdatedAt !== sessionStorageUpdatedAt) {
                throw new Error(outOfSyncErrorMessage);
            }
        }
        if (values.sessionInfo.method === '')
            delete values.sessionInfo.method;
        return axios.request({
            method: values.id ? 'PUT' : 'POST',
            data: values,
            url: values.id ? "/api/v1/notes/".concat(values.id) : "/api/v1/notes/",
        });
    }, {
        onError: onError,
        onSuccess: function (_a, variables) {
            var _b, _c, _d, _e, _f, _g;
            var data = _a.data;
            // use directly instead of hooks since ID not available at base level
            window.localStorage.setItem(syncStorageKey((_b = data.data.id) !== null && _b !== void 0 ? _b : ''), (_d = (_c = data.data.updatedAt) !== null && _c !== void 0 ? _c : data.data.createdAt) !== null && _d !== void 0 ? _d : '');
            window.sessionStorage.setItem(syncStorageKey((_e = data.data.id) !== null && _e !== void 0 ? _e : ''), (_g = (_f = data.data.updatedAt) !== null && _f !== void 0 ? _f : data.data.createdAt) !== null && _g !== void 0 ? _g : '');
            queryCache.setQueryData(['note', data.data.id], data.data);
            queryClient.invalidateQueries('past_interactions');
            queryClient.invalidateQueries('todo_notes');
            queryClient.invalidateQueries('notes');
            queryClient.invalidateQueries('template'); // make sure copy forward doesn't hang on to old data
            if (data.data.rotomAppointmentId) {
                // update note setup
                queryCache.setQueryData(['note-setup', data.data.rotomAppointmentId], __assign(__assign({}, noteSetupState.noteSetupQuery.data), { existingNote: data.data }));
            }
            onSuccess(data.data, variables);
        },
        onSettled: function (data) { var _a; return onSettled((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.data); },
    });
};
